/* eslint-disable */
import { createSelector, } from 'reselect';
import { MODULE_NAME, } from './../constants';


export const moduleState = state => state[MODULE_NAME];
export const fetching = createSelector(
  moduleState,
  m => m.fetching
);
export const status = createSelector(
  moduleState,
  m => m.status
);
export const authToken = createSelector(
  moduleState,
  m => m.authToken
);
export const creditCard = createSelector(
  moduleState,
  m => m.creditCard
);
export const main = createSelector(
  moduleState,
  m => m.main
);
export const paypal = createSelector(
  moduleState,
  m => m.paypal
);

export function FN_paypalFrom(l) {
  return {
    condition: !!l.token && !!l.id && !!l.orderNumber,
    data: {
      subscription_id: l.subscriptionId || null,
      token: l.token,
      payment_method_id: l.id,
    },
  }
}

export function FN_creditcardFrom(l) {
  return {
    condition: !!l.creditcard && !!l.nonce,
    data: {
      nonce: l.nonce,
    },
  }
}
